export const CUSTOMER_INFORMATION_MODAL_BUTTONS_PADDING_Y = 1.1;
export const CUSTOMER_INFORMATION_MODAL_BUTTONS_MARGIN_Y = 1.3;
export const CUSTOMER_INFORMATION_MODAL_TEXTINPUT_PADDING_X = 1;